import { useMemo } from 'react';
import { useGroupRules } from 'src/graphql';
import { SITE_TABS, SiteTab } from './site-const';

/**
 * The site tabs the current user is allowed to see, in display order.
 *
 * `loading` matters for deep links: while the group rules resolve, every gated tab
 * (AI Summary, Activity) is filtered out, so a consumer resolving a `/sites/{id}/{tab}`
 * URL must not treat an unmatched slug as invalid until this flips to `false`.
 */
export const useSiteTabs = (): { tabs: SiteTab[]; loading: boolean } => {
  const { checkValidity, loading } = useGroupRules();

  const tabs = useMemo(
    () =>
      SITE_TABS.filter(
        (tab) =>
          !tab.allowedRules ||
          (!loading && checkValidity(tab.allowedRules, { matchType: 'any' })),
      ),
    [checkValidity, loading],
  );

  return { tabs, loading };
};
